import { Injectable } from '@angular/core';
import { ApiConfigService } from './api-config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Banner } from '../../models/banner.interface';

@Injectable({
  providedIn: 'root'
})
export class BannerService {
  private get apiUrl(): string { return `${this.apiConfig.apiUrl}/banners`; }

  constructor(private http: HttpClient, private apiConfig: ApiConfigService) {}

  getBanners(): Observable<Banner[]> {
    return this.http.get<Banner[]>(this.apiUrl);
  }

  getBannerById(id: string): Observable<Banner> {
    return this.http.get<Banner>(`${this.apiUrl}/${id}`);
  }

  createBanner(bannerData: Partial<Banner>): Observable<Banner> {
    return this.http.post<Banner>(this.apiUrl, bannerData);
  }

  updateBanner(id: string, bannerData: Partial<Banner>): Observable<Banner> {
    return this.http.put<Banner>(`${this.apiUrl}/${id}`, bannerData);
  }

  deleteBanner(id: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${id}`);
  }
}



